import betstationRoutes from './betstation.routes';
import bingoRoutes from './bingo.routes';
import casinoRoutes from './casino.routes';
import engagementRoutes from './engagement.routes';
import horseRacingRoutes from './horseracing.routes';
import lotteryRoutes from './lottery.routes';
import mobilePortalRoutes from './mobile-portal.routes';
import mokabingoRoutes from './mokabingo.routes';
import myaccountRoutes from './myaccount.routes';
import oxygenRoutes from './oxygen.routes';
import paymentsRoutes from './payments.routes';
import pokerRoutes from './poker.routes';
import promoRoutes from './promo.routes';
import { RoutesConfig } from './routes-config';
import sportsRoutes from './sports.routes';

const routes: RoutesConfig = {
    routes: [
        ...mobilePortalRoutes.routes,
        ...oxygenRoutes.routes,
        ...sportsRoutes.routes,
        ...promoRoutes.routes,
        ...myaccountRoutes.routes,
        ...lotteryRoutes.routes,
        ...horseRacingRoutes.routes,
        ...bingoRoutes.routes,
        ...mokabingoRoutes.routes,
        ...casinoRoutes.routes,
        ...pokerRoutes.routes,
        ...engagementRoutes.routes,
        ...paymentsRoutes.routes,
        ...betstationRoutes.routes,
    ],
    topLevelRoutes: [...sportsRoutes.topLevelRoutes],
};

export default routes;
